import { cloneDeep, isObject } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Editor } from '@meitu/saas-editor-core/es/editor';
import { ILayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';

// function isChanged<T>(prev: T, next: T) {
//     if (prev === null && next === null) return false;
//     if (prev === null || next === null) return true;
//     if (isObject(prev) && isObject(next)) {
//         const keys = Object.keys(prev);
//         for (let i = 0; i < keys.length; i++) {
//             const key = keys[i];
//             // 递归比较嵌套对象
//             if (isObject(prev[key]) && isObject(next[key])) {
//                 if (isChanged(prev[key], next[key])) {
//                     return true;
//                 }
//             } else if (prev[key] !== next[key]) {
//                 return true;
//             }
//         }
//     } else {
//         return prev !== next;
//     }
//     return false;
// }

function isChanged<T>(prev: T, next: T) {
    if (prev === null && next === null) return false;
    if (prev === null || next === null) return true;
    if (isObject(prev) && isObject(next)) {
        return JSON.stringify(prev) !== JSON.stringify(next);
    }
    return prev !== next;
}

/** 监听选中图层的变化 */
export const useListenActiveLayerProps = <T>(
    editor: Editor,
    pickDataFn: (layer: ILayerProps | null) => T,
    listener = true,
) => {
    const layer = listener ? editor.services.frame.getActiveLayer() : null;
    const dataRef = useRef(listener ? pickDataFn(layer) : null);

    const [_, refresh] = useState(0);
    const typeRef = useRef<LayerType | undefined>(layer?.layerType);

    useEffect(() => {
        if (!listener) return;
        const handler = editor.services.frame.onActiveLayerDataUpdate((layer) => {
            if (typeRef.current && layer?.layerType === typeRef.current) {
                const data = pickDataFn(layer);
                if (isChanged(dataRef.current, data)) {
                    dataRef.current = data;
                    refresh((prev) => prev + 1);
                }
            }
        });

        return () => {
            editor.off(handler);
        };
    }, [listener]);

    return dataRef.current;
};

/** 监听选中子图层的变化，没有子图层时，监听选中图层 */
export const useListenActivePickLayerProps = <T>(
    editor: Editor,
    pickDataFn: (layer: ILayerProps | null) => T,
    force = true,
    listener = true,
) => {
    const layer = listener ? editor.services.frame.getActivePickLayer(force) : null;
    const dataRef = useRef(listener ? pickDataFn(layer) : null);

    const [_, refresh] = useState(0);
    const typeRef = useRef<LayerType | undefined>(layer?.layerType);

    useEffect(() => {
        if (!listener) return;
        const handler = editor.services.frame.onActiveLayerDataUpdate(() => {
            const layer = editor.services.frame.getActivePickLayer(force);
            if (force === false || (typeRef.current && layer?.layerType === typeRef.current)) {
                const data = pickDataFn(layer);
                if (isChanged(dataRef.current, data)) {
                    dataRef.current = data;
                    refresh((prev) => prev + 1);
                }
            }
        });
        return () => editor.off(handler);
    }, [listener]);

    return dataRef.current;
};
